import BaseService from '@/services/BaseService'
import TempAccount from '@/models/tempAccount'
import Service from '@/models/service'
import { GenericUser } from '@/models/user'

export class TempAccountService extends BaseService<TempAccount> {
  constructor() {
    super('temporary-accounts/')
  }

  public async search(filter: string): Promise<TempAccount[]> {
    const result = await this.instance.get<TempAccount[]>(
      this.resourcePath + 'search/',
      {
        params: {
          filter,
        },
      },
    )
    return result.data
  }

  public async createTempAccount(data: any): Promise<TempAccount> {
    const result = await this.instance.post(
      this.resourcePath + '/create/',
      data,
    )
    return result.data
  }

  public async updateTempAccount(
    account: TempAccount,
    services: number[],
    role: string,
    target: string,
    school: string | null,
  ): Promise<TempAccount> {
    const result = await this.instance.put(
      this.resourcePath + account.ad_personne_id + '/',
      {
        account,
        services,
        role,
        target,
        school,
      },
    )
    return result.data
  }

  public async getDetails(ad_personne_id: number | string): Promise<any> {
    const result = await this.instance.get(
      this.resourcePath + ad_personne_id + '/details/',
    )
    return result.data
  }

  public async userMassInsert(formData: FormData): Promise<any> {
    const result = await this.instance.post(
      this.resourcePath + 'users-import-csv/',
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    )
    return result.data as any
  }

  public async enable(ad_personne_id: number, username: string): Promise<any> {
    const result = await this.instance.put(
      this.resourcePath + ad_personne_id + '/enable/',
      { username },
    )
    return result.data
  }

  public async disable(ad_personne_id: number, username: string): Promise<any> {
    const result = await this.instance.put(
      this.resourcePath + ad_personne_id + '/disable/',
      { username },
    )
    return result.data
  }

  public async delete(tempAccount: any): Promise<any> {
    const data = { username: tempAccount.identifiant }
    const result = await this.instance.delete(
      this.resourcePath + tempAccount.ad_personne_id + '/delete/',
      { data },
    )
    return result.data
  }

  public async extend(
    ad_personne_id: number,
    date: string,
    username: string,
  ): Promise<any> {
    const result = await this.instance.put(
      this.resourcePath + ad_personne_id + '/extend/',
      { date, username },
    )
    return result.data
  }

  public async fetchDescriptions(): Promise<any> {
    const result = await this.instance.get(this.resourcePath + '/descriptions/')
    return result.data
  }

  public async resetUserPassword(account: TempAccount | GenericUser) {
    const result = await this.instance.post(
      this.resourcePath + 'reset-password/',
      {
        account,
      },
    )
    return result.data
  }

  public async checkForExistingMail(email: string) {
    const result = await this.instance.get(this.resourcePath + 'email/', {
      params: {
        email,
      },
    })
    return result.data
  }

  public async checkForExistingMailInUpdate(
    email: string,
    ad_personne_id: number,
  ) {
    const result = await this.instance.get(this.resourcePath + 'email/', {
      params: {
        email,
        ad_personne_id,
      },
    })
    return result.data
  }

  public async checkForExistingUsername(username: string) {
    const result = await this.instance.get(
      this.resourcePath + 'username/' + '?username=' + username,
    )
    return result.data
  }
}

export default new TempAccountService()
